export const initialRange = [7, 7];
export const millisecondsInDay = 86400000;
